import { useMemo } from "react"
import { Roles, rolesList } from "@/shared/constants/roles"
import { KeycloakTokenParsed } from "keycloak-js";

const rolesSet = new Set<Roles>(rolesList);

export const useDefineRole = (token?: KeycloakTokenParsed) => {

  return useMemo(() => {
    if (!token) return null

    const frontolCloudClientRoles = token.resource_access?.frontol_cloud_client?.roles || []
    const frontolCode = token.frontol_code

    // Пеовый вход, роль пользователя не определена.
    if (frontolCloudClientRoles.length === 0 && !frontolCode) return null
    const roles = frontolCloudClientRoles
      .filter(role => rolesSet.has(role as Roles))
      .sort((current, next) => rolesList.indexOf(current as Roles) > rolesList.indexOf(next as Roles) ? 1 : -1)

    if (roles.length === 0) {
      console.warn(`Роли пользователя ([${frontolCloudClientRoles.join(', ')}]) не найдены в списке доступных.`)
      return null
    };
    return roles[0] as Roles
  }, [token]);
};
